<template>
  <div v-if="labels">
    <vs-row>
      <vx-card class="max-w-lg">
        <div v-if="title" class="border-dotted border-b-2 border-0 border-grey pb-4 flex justify-center">
          <span
            ><b>{{ title }}</b></span
          >
        </div>

        <transition name="fade">
          <segmentation-row
            icon="HomeIcon"
            class="my-4"
            v-if="showVenues"
            @onDelete="onDeleteVenues"
            :removeX="deactivateVenueSelect || deactivateAll"
          >
            <div>Venues</div>
            <div class="text-grey">must be on one of the venues</div>
            <template v-slot:result>
              <venue-selector
                v-model="guestQuery.consentVenues"
                :multiple="true"
                placeholder="Select venues"
                :deactivated="deactivateVenueSelect || deactivateAll"
              />
            </template>
          </segmentation-row>
        </transition>

        <transition name="fade">
          <segmentation-row icon="GiftIcon" class="my-4" v-if="showAge" @onDelete="onDeleteAge" :removeX="deactivateAll">
            <div>Age</div>
            <div class="text-grey">between {{ guestQuery.minAge }} - {{ guestQuery.maxAge }}</div>

            <template v-slot:result>
              <vs-slider v-model="mappedAgeRange" :disabled="deactivateAll" />
            </template>
          </segmentation-row>
        </transition>

        <transition name="fade">
          <segmentation-row icon="TagIcon" class="my-4" v-if="showLabels" @onDelete="onDeleteLabels" :removeX="deactivateAll">
            <div>Labels</div>
            <div class="text-grey">Must have all labels</div>

            <template v-slot:result>
              <treeselect
                v-if="labels"
                :disabled="deactivateAll"
                ref="treeselect"
                v-model="guestQuery.labels"
                :multiple="true"
                :options="mappedLabels"
                placeholder="Select labels"
                :flatten-search-results="true"
                value-consists-of="LEAF_PRIORITY"
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.label }}
                </div>
              </treeselect>
            </template>
          </segmentation-row>
        </transition>

        <transition name="fade">
          <segmentation-row icon="ShoppingCartIcon" class="my-4" v-if="showInterest" @onDelete="onDeleteInterest" :removeX="deactivateAll">
            <div>Interest</div>
            <div class="text-grey">Must have interest</div>

            <template v-slot:result>
              <div>
                <treeselect
                  v-if="labels"
                  :disabled="deactivateAll"
                  ref="treeselect"
                  v-model="guestQuery.interestKey"
                  :multiple="false"
                  :options="mappedInterests"
                  placeholder="Select interest"
                  :flatten-search-results="true"
                  value-consists-of="LEAF_PRIORITY"
                >
                  <div slot="value-label" slot-scope="{ node }">
                    {{ node.raw.label }}
                  </div>
                </treeselect>
              </div>
              <div class="mx-2">=</div>
              <div class="flex-grow">
                <vs-input style="width: 160px" v-model="guestQuery.interestValue"></vs-input>
              </div>
            </template>
          </segmentation-row>
        </transition>

        <transition name="fade">
          <segmentation-row
            icon="LinkIcon"
            class="my-4"
            v-if="showConsents && !dontShowConsentsRow"
            @onDelete="onDeleteConsents"
            :removeX="deactivateAll || !canRemoveConsent"
          >
            <div>Permissions</div>
            <div class="text-grey">Must have consent for permissions</div>

            <template v-slot:result>
              <div class="flex flex-col">
                <div class="flex-shrink mt-2">
                  <treeselect
                    v-if="labels"
                    :disabled="deactivateAll || deactivateConsentSelect"
                    ref="treeselect"
                    v-model="guestQuery.consentPermissions"
                    :multiple="true"
                    :options="mappedPermissions"
                    placeholder="Select consented permissions"
                    :flatten-search-results="true"
                    value-consists-of="LEAF_PRIORITY"
                  >
                    <div slot="value-label" slot-scope="{ node }">
                      <span>{{ node.raw.label }}</span>
                    </div>
                  </treeselect>
                </div>
              </div>
            </template>
          </segmentation-row>
        </transition>

        <transition name="fade">
          <segmentation-row icon="CreditCardIcon" class="my-4" v-if="showFixrEvent" @onDelete="onDeleteFixrEvent" :removeX="deactivateAll">
            <div>Fixr event</div>
            <div class="text-grey">Filter by tickets bought for event</div>
            <!-- Tooltip with (i) icon to describe how to use it -->

            <template v-slot:result>
              <vs-textarea style="margin-bottom: -2px" class="w-full" v-model="guestQuery.fixrEventFilter"></vs-textarea>
              <!-- <vs-select v-model="guestQuery.fixrEventNumTicketsOperator" class="w-24 mx-2">
                <vs-select-item :key="0" value="0" text="=" />
                <vs-select-item :key="1" value="1" text="<" />
                <vs-select-item :key="2" value="2" text=">" />
              </vs-select>
              <vs-input v-model="guestQuery.fixrEventNumTickets" class="w-24"></vs-input> -->
            </template>

            <!-- <template v-slot:result>
              <div class="flex flex-col">
                <div class="flex-shrink mt-2">
                  <treeselect
                    v-if="labels"
                    :disabled="deactivateAll || deactivateConsentSelect"
                    ref="treeselect"
                    v-model="guestQuery.consentPermissions"
                    :multiple="true"
                    :options="mappedPermissions"
                    placeholder="Select consented permissions"
                    :flatten-search-results="true"
                    value-consists-of="LEAF_PRIORITY"
                  >
                    <div slot="value-label" slot-scope="{ node }">
                      <span>{{ node.raw.label }}</span>
                    </div>
                  </treeselect>
                </div>
              </div>
            </template> -->
          </segmentation-row>
        </transition>

        <!-- Add new button -->
        <div
          class="flex items-center"
          v-if="!deactivateAll && (!showAge || !showLabels || !showInterest || !showConsents || !showVenues || !showFixrEvent)"
        >
          <div
            class="p-2 rounded-lg transition-all duration-150"
            :class="{ 'pl-4': hoveringNew }"
            @mouseenter="hoveringNew = true"
            @mouseleave="hoveringNew = false"
          >
            <div class="flex items-center pr-8">
              <div class="mr-4 flex items-center">
                <feather-icon icon="PlusIcon" svgClasses="w-4 h-4"></feather-icon>
                <span class="ml-2">Add new condition</span>
              </div>

              <div
                class="color-box flex-shrink-0 mx-1 cursor-pointer"
                :class="{ hide: !hoveringNew, hidden: showVenues }"
                @click="AddCanSeeVenues"
              >
                <feather-icon icon="HomeIcon" svgClasses="w-4 h-4"></feather-icon>
              </div>

              <div
                class="color-box flex-shrink-0 mx-1 cursor-pointer"
                :class="{ hide: !hoveringNew, hidden: showAge }"
                @click="guestQuery.hasAge = true"
              >
                <feather-icon icon="GiftIcon" svgClasses="w-4 h-4"></feather-icon>
              </div>
              <div
                class="color-box flex-shrink-0 mx-1 cursor-pointer"
                :class="{ hide: !hoveringNew, hidden: showLabels }"
                @click="guestQuery.hasLabels = true"
              >
                <feather-icon icon="TagIcon" svgClasses="w-4 h-4"></feather-icon>
              </div>
              <div
                class="color-box flex-shrink-0 mx-1 cursor-pointer"
                :class="{ hide: !hoveringNew, hidden: showInterest }"
                @click="guestQuery.hasInterest = true"
              >
                <feather-icon icon="ShoppingCartIcon" svgClasses="w-4 h-4"></feather-icon>
              </div>
              <div
                class="color-box flex-shrink-0 mx-1 cursor-pointer"
                :class="{ hide: !hoveringNew, hidden: showConsents }"
                @click="guestQuery.hasConsents = true"
              >
                <feather-icon icon="LinkIcon" svgClasses="w-4 h-4"></feather-icon>
              </div>
              <div
                class="color-box flex-shrink-0 mx-1 cursor-pointer"
                :class="{ hide: !hoveringNew, hidden: showFixrEvent }"
                @click="guestQuery.hasFixrEvent = true"
              >
                <feather-icon icon="CreditCardIcon" svgClasses="w-4 h-4"></feather-icon>
              </div>
            </div>
          </div>
        </div>

        <div class="border-dotted border-t-2 border-0 border-grey pt-4">
          <div class="flex items-center">
            <vs-button class="px-5 mr-2" @click="submitQuery" :disabled="!isQueryValid">Calculate audience</vs-button>

            <div v-if="isQuerying" class="ml-4">
              <span class="flex h-4 w-4 mt-2">
                <span class="animate-ping absolute inline-flex h-4 w-4 rounded-full bg-primary opacity-75"></span>
                <span class="relative inline-flex rounded-full h-4 w-4 bg-primary"></span>
              </span>
            </div>
            <div v-if="queryResult != -1 && !isQuerying" class="ml-4 flex items-center">
              <b>Estimated number of guests:</b>
              <span class="ml-2">{{ queryResult }}</span>
              <feather-icon class="ml-1" icon="UserIcon" svgClasses="w-4 h-4"></feather-icon>
            </div>
          </div>
        </div>
      </vx-card>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
// import styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import VenueSelector from "@/components/VenueSelector.vue";

import SegmentationRow from "./SegmentationRow.vue";
export default {
  components: {
    Treeselect,
    SegmentationRow,
    VenueSelector
  },
  props: {
    guestQuery: {
      type: Object,
      required: true
    },
    deactivateVenueSelect: {
      type: Boolean,
      required: false
    },
    deactivateConsentSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    dontShowConsentsRow: {
      type: Boolean,
      required: false,
      default: false
    },
    canRemoveConsent: {
      type: Boolean,
      required: false,
      default: false
    },
    deactivateAll: {
      type: Boolean,
      required: false
    },
    title: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      hoveringNew: false,
      queryResult: -1,

      isQuerying: false
    };
  },
  methods: {
    AddCanSeeVenues() {
      this.guestQuery.hasVenues = true;
      console.log("TEST", this.guestQuery);
    },
    onDeleteAge() {
      this.guestQuery.hasAge = false;
    },
    onDeleteLabels() {
      this.guestQuery.hasLabels = false;
    },
    onDeleteInterest() {
      this.guestQuery.hasInterest = false;
    },
    onDeleteVenues() {
      this.guestQuery.hasVenues = false;
    },
    onDeleteConsents() {
      this.guestQuery.hasConsents = false;
    },
    onDeleteFixrEvent() {
      console.log("DELETING FIXR EVENT");
      this.guestQuery.hasFixrEvent = false;
    },
    async submitQuery() {
      console.log("Submitted query", this.guestQuery);
      this.isQuerying = true;
      const result = await this.$store.dispatch("userProfiles/getCountByGuestQuery", this.guestQuery);
      this.queryResult = result;
      this.isQuerying = false;
    }
  },
  computed: {
    ...mapGetters({
      labels: "guestSegmentation/labels",
      interests: "guestSegmentation/interests",
      consentTypes: "guestProfiles/consentTypes",
      consentNames: "guestProfiles/consentNames",
      guestPermissions: "legalDocuments/guestPermissions"
    }),
    isQueryValid() {
      let queryValid = true;

      if (this.showVenues && this.guestQuery.consentVenues.length == 0) queryValid = false;

      if (this.showLabels && this.guestQuery.labels.length == 0) queryValid = false;

      if (this.showInterest && (!this.guestQuery.interestKey || !this.guestQuery.interestValue)) queryValid = false;

      if (this.showConsents && this.guestQuery.consentPermissions.length == 0) queryValid = false;

      if (this.showFixrEvent) {
        if (this.guestQuery.fixrEventFilter == null || this.guestQuery.fixrEventFilter.length == 0) queryValid = false;
        // if (this.guestQuery.fixrEventNumTicketsOperator < 0 || this.guestQuery.fixrEventNumTicketsOperator > 2) queryValid = false;
      }

      console.log("Emitting valid", queryValid);
      this.$emit("validQuery", queryValid);
      return queryValid;
    },
    showVenues() {
      return this.guestQuery.hasVenues;
    },
    showAge() {
      return this.guestQuery.hasAge;
    },
    showLabels() {
      return this.guestQuery.hasLabels;
    },
    showInterest() {
      return this.guestQuery.hasInterest;
    },
    showConsents() {
      return this.guestQuery.hasConsents;
    },
    showFixrEvent() {
      return this.guestQuery.hasFixrEvent;
    },
    mappedAgeRange: {
      get() {
        return [this.guestQuery.minAge, this.guestQuery.maxAge];
      },
      set(value) {
        [this.guestQuery.minAge, this.guestQuery.maxAge] = value;
      }
    },
    mappedLabels() {
      return this.labels.map(label => ({
        id: label,
        label: label
      }));
    },
    mappedInterests() {
      return this.interests.map(interest => ({
        id: interest.name,
        label: interest.name
      }));
    },
    mappedConsents() {
      let consents = [];

      this.consentTypes.forEach((type, idx) => {
        const consentName = this.consentNames[idx];
        consents.push({
          id: type,
          label: consentName
        });
      });
      return consents;
    },
    mappedPermissions() {
      return this.guestPermissions.map((permission, idx) => {
        return {
          id: permission.id,
          label: permission.title
        };
      });
    }
  },

  async mounted() {
    this.$vs.loading();
    console.log("Initial query", this.guestQuery);
    await Promise.all([this.$store.dispatch("guestSegmentation/get"), this.$store.dispatch("legalDocuments/getAllGuestPermissions")]);
    this.$vs.loading.close();
  }
};
</script>

<style lang="scss" scoped>
.color-box {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background-color: rgba(var(--vs-primary)) !important;
  box-shadow: 0px 15px 40px -10px rgba(var(--vs-primary), 0.9);

  display: flex;
  align-items: center;
  justify-content: center;

  color: white;

  opacity: 1;
  transition: opacity 0.15s;

  &.hide {
    opacity: 0;
    pointer-events: none;
  }
}
</style>